export default "__VITE_ASSET__BOgf$pP1__"